'use strict';

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

const LINE_TARGETS_SELECTOR = '.tc-website-rootcontainer--bottom-line, .neos-nodetypes-multicolumn.with-vertical-line, .tc-website-projects-slider, .tc-website-project-detail__content';
const ACTIVE_CLASS = 'is-line-visible';
const ENABLED_CLASS = 'line-animations-enabled';
const TRANSITIONS_READY_CLASS = 'line-animations-transitions-ready';
const TRIGGER_RATIO = 0.8;
const REVEAL_DELAY_MS = 120;
const REVEAL_STAGGER_MS = 320;
const REVEAL_STATE_ATTRIBUTE = 'lineRevealScheduled';
const nextRevealAtByGroup = new Map();

const getRevealGroup = (element) => {
  if (element.classList.contains('tc-website-rootcontainer--bottom-line')) return 'rootcontainer-bottom-line';
  if (element.classList.contains('with-vertical-line')) return 'multicolumn-vertical-line';
  if (element.classList.contains('tc-website-projects-slider')) return 'projects-slider-line';
  if (element.classList.contains('tc-website-project-detail__content')) return 'project-detail-content-line';
  return 'default-line-group';
};

const revealLine = (element, delay = REVEAL_DELAY_MS) => {
  if (element.classList.contains(ACTIVE_CLASS) || element.dataset[REVEAL_STATE_ATTRIBUTE] === '1') return;

  const group = getRevealGroup(element);
  const now = performance.now();
  const earliestStartAt = now + delay;
  const nextGroupAvailableAt = nextRevealAtByGroup.get(group) || 0;
  const scheduledAt = Math.max(earliestStartAt, nextGroupAvailableAt);
  const timeoutMs = Math.max(0, Math.round(scheduledAt - now));

  nextRevealAtByGroup.set(group, scheduledAt + REVEAL_STAGGER_MS);
  element.dataset[REVEAL_STATE_ATTRIBUTE] = '1';

  window.setTimeout(() => {
    window.requestAnimationFrame(() => {
      element.classList.add(ACTIVE_CLASS);
      delete element.dataset[REVEAL_STATE_ATTRIBUTE];
    });
  }, timeoutMs);
};

const isAtTriggerPoint = (element) => {
  const rect = element.getBoundingClientRect();
  const triggerY = window.innerHeight * TRIGGER_RATIO;
  return rect.top <= triggerY && rect.bottom > 0;
};

const init = () => {
  const lineTargets = Array.from(document.querySelectorAll(LINE_TARGETS_SELECTOR));
  if (!lineTargets.length) return;

  document.body.classList.add(ENABLED_CLASS);
  gsap.registerPlugin(ScrollTrigger);

  // Let the hidden initial state paint once so in-view lines
  // still animate when entering a page directly on that section.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      document.body.classList.add(TRANSITIONS_READY_CLASS);

      lineTargets.forEach((element) => {
        ScrollTrigger.create({
          trigger: element,
          start: 'top 80%',
          once: true,
          onEnter: () => revealLine(element)
        });
      });

      ScrollTrigger.refresh();

      // Ensure sections already visible on initial page load
      // still animate from the collapsed line state.
      lineTargets
        .filter((element) => !element.classList.contains(ACTIVE_CLASS) && isAtTriggerPoint(element))
        .forEach((element, index) => {
          revealLine(element, REVEAL_DELAY_MS + (REVEAL_STAGGER_MS * index));
        });
    });
  });
};

export default {init};
